(() => {
  'use strict';

  const guide = document.querySelector('.wf-flower-guide');
  if (!guide) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const familyFromHash = (hash) => {
    if (!hash || hash === '#') return null;
    let id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (_error) {
      return null;
    }
    const target = document.getElementById(id);
    return target instanceof HTMLDetailsElement && target.classList.contains('wf-fg-family')
      ? target
      : null;
  };

  const revealFamily = (hash, { focus = true, scroll = true } = {}) => {
    const target = familyFromHash(hash);
    if (!target) return false;

    target.open = true;
    target.classList.add('is-visible');
    const summary = target.querySelector('summary');
    window.requestAnimationFrame(() => {
      if (scroll) {
        target.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'start',
        });
      }
      if (focus && summary) summary.focus({ preventScroll: true });
    });
    return true;
  };

  guide.addEventListener('click', (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      !(event.target instanceof Element)
    ) {
      return;
    }

    const link = event.target.closest('a[href^="#"]');
    const href = link?.getAttribute('href');
    if (!href || !familyFromHash(href)) return;

    event.preventDefault();
    window.history.pushState(null, '', href);
    revealFamily(href);
  });

  const careGuide = guide.querySelector('.wf-fg-care-guide');
  const tabList = careGuide?.querySelector('[role="tablist"]');
  const tabs = tabList ? [...tabList.querySelectorAll('[role="tab"]')] : [];

  if (careGuide && tabs.length === 2) {
    const activateTab = (activeTab, focus = false) => {
      tabs.forEach((tab) => {
        const selected = tab === activeTab;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (panel) panel.hidden = !selected;
      });
      if (focus) activeTab.focus();
    };

    careGuide.classList.add('is-enhanced');
    activateTab(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0]);

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', (event) => {
        let nextIndex = null;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === null) return;

        event.preventDefault();
        activateTab(tabs[nextIndex], true);
      });
    });
  }

  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    const revealItems = [...guide.children];
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -8% 0px' },
    );

    revealItems.forEach((item) => {
      item.classList.add('wf-fg-reveal');
      const bounds = item.getBoundingClientRect();
      if (bounds.bottom > 0 && bounds.top < window.innerHeight * 0.92) {
        item.classList.add('is-visible');
      } else {
        revealObserver.observe(item);
      }
    });
    guide.classList.add('is-reveal-ready');
  }

  if (window.location.hash) revealFamily(window.location.hash, { focus: false });
  window.addEventListener('hashchange', () => revealFamily(window.location.hash, { focus: false }));
})();
